<template>
  <!--
    	作者：kmdshop
    	时间：2020-06-20
    	描述：diy组件-参数设置-搜索栏
    -->
  <div>
    <div class="common-form"><span>{{ curItem.name }}</span></div>
     <el-form size="small" :model="curItem" label-width="100px">
      

       <el-form-item label="顶部距离：">
         <el-input v-model="curItem.params.top_rpx" style="width: 200px;"></el-input>rpx
       </el-form-item>


       <!--图标链接-->
       <el-form-item label="链接：">
           <el-input v-model="curItem.params.icon_link"></el-input>
           <div class="url-box" >
             <el-button type="primary" @click="changeLink(index)" style="margin-top:10px;">选择链接</el-button>
           </div>
       </el-form-item>
    </el-form>

    <!--上传图片组件-->
    <!-- <Upload v-if="isupload" :isupload="isupload" :type="type" @returnImgs="returnImgsFunc">上传图片</Upload> -->
    <SetLink v-if="is_linkset" :is_linkset="is_linkset" @closeDialog="closeLinkset">选择链接</SetLink>
  </div>
</template>

<script>
  import Upload from '@/components/file/Upload';
  import SetLink from '@/components/setlink/Setlink';
  export default {
    components: {
      Upload,
      SetLink,
    },
    data() {
      return {
        image_id:'',
         /*是否上传图片*/
        isupload: false,
        index: null,
        urlList : [],
        /*是否选择链接*/
        is_linkset: false,
        type:1,
      };
    },
    props: ['curItem', 'selectedIndex', 'opts'],
    created() {

    },
    methods: {
      /*上传*/
      openUpload(e) {
        this.type = e;
        this.isupload = true;
      },
      /*获取图片*/
      returnImgsFunc(e) {
        console.log(e);
        if (e != null && e.length > 0) {
          this.file_path = e[0].file_path;
          this.image_id = e[0].file_id;
          this.curItem.params.img_url = this.file_path;
        }
        this.isupload = false;
      },


      /*选择链接*/
        changeLink(index) {
            this.is_linkset = true;
            this.index = index;
        },

    /*获取链接并关闭弹窗*/
      closeLinkset(e) {
          this.is_linkset = false;
          if (e) {
            this.curItem.params.icon_link = e.url
            // this.curItem.data[this.index].name = e.name
          }
      },
    }
  };
</script>

<style scoped>
  .img {
     margin-top: 10px;
   }
</style>



// WEBPACK FOOTER //
// src/views/page/page/diy/params/Gys.vue